// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a326d3f8","455":"297669ae"}[chunkId] + ".chunk.js";
};